import React, { useState } from "react";
import { IoClose } from "react-icons/io5";
import { FaSave } from "react-icons/fa";
import { MdDataSaverOff } from "react-icons/md";
import { Input, DatePickerComp } from "../Form";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const TryoutModel = ({ isOpen, onClose }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [startDate, setStartDate] = useState(new Date());

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50 overflow-y-scroll">
      <div className="bg-white md:p-5 p-4 rounded shadow-md md:w-[80%] w-full md:m-0 m-3">
        <div className="flex gap-5 justify-between">
          <button
            className=" uppercase text-red-500 flex items-center md:gap-2 gap-1"
            onClick={onClose}
          >
            <IoClose className="font-semibold uppercase" />
            cancel
          </button>
          <h1 className="uppercase text-[#66b5a3] font-semibold">
            Add Tryout
          </h1>
          <button
            className=" uppercase hover:text-[#539e93] text-[#66b5a3] flex items-center md:gap-2 gap-1"
            onClick={onClose}
          >
            <FaSave className=" font-semibold uppercase" />
            save
          </button>
        </div>

        <div className="pt-5">
          <Input label="Name" color={true} placeholder={"Enter Name"} />

          <div className="my-3">
            <DatePickerComp
              placeholder="Choose Date"
              label={"Ship Date"}
              selected={startDate}
              onChange={"onChange"}
              className="bg-transparent"
              />
          </div>

          <DatePickerComp
            placeholder="Choose Date"
            label={"Appointment"}
            selected={startDate}
            onChange={"onChange"}
            className="bg-transparent"
          />

          <button
            className=" uppercase flex items-center gap-2 md:mt-8 mt-4 bg-[#66b5a3] hover:bg-[#539e93] text-white justify-center w-full rounded-md p-3"
            onClick={onClose}
          >
            <FaSave className="text-white font-semibold uppercase" />
            save
          </button>
        </div>
        <div className="flex md:text-center text-start gap-3 mt-6 md:mx-4 mx-0 md:mb-10">
          <MdDataSaverOff className="text-[#66b5a3] md:text-2xl text-6xl" />
          <p className="text-sm text-[#393e46] font-normal">
            You can define tasks so technicians can quickly choose what they
            have done. It is useful for statistics, for example how many tasks
            technician has done for certain period.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TryoutModel;
